<template>
    <TSearchbar />
</template>

<script>
import TSearchbar from '../../../templates/terminal/t-searchbar';

export default {
    name: "PSearchbar",
    components: {
        TSearchbar
    }
}
</script>